var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-linear',{staticClass:"top_progress_bar",attrs:{"rounded":"","height":"5","active":_vm.getAppBarLoadingFlag,"indeterminate":true,"top":"","color":"primary","background-color":"white","background-opacity":"1"}})
}
var staticRenderFns = []

export { render, staticRenderFns }